// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1upOl","inner":"Footer_inner__nY1lE"};